import { Link } from "@tanstack/react-router";
import { BookOpenCheck, LogOut, UserRound } from "lucide-react";

import { authClient } from "../lib/auth-client";
import ThemeToggle from "./ThemeToggle";

function HeaderAccount() {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return <span className="account-skeleton" aria-hidden="true" />;
  }

  if (!session?.user) {
    return (
      <Link to="/auth" className="nav-button">
        <UserRound className="h-4 w-4" aria-hidden="true" />
        Sign in
      </Link>
    );
  }

  return (
    <div className="account-chip">
      <span>{session.user.name?.slice(0, 1) || session.user.email.slice(0, 1)}</span>
      <button
        type="button"
        onClick={() => {
          void authClient.signOut();
        }}
      >
        <LogOut className="h-4 w-4" aria-hidden="true" />
        <span className="sr-only">Sign out</span>
      </button>
    </div>
  );
}

export default function Header() {
  return (
    <header className="site-header">
      <nav className="page-wrap nav-shell">
        <Link to="/" className="brand-link">
          <BookOpenCheck className="h-5 w-5" aria-hidden="true" />
          Bookling
        </Link>

        <div className="nav-links">
          <Link
            to="/"
            className="nav-link"
            activeProps={{ className: "nav-link is-active" }}
            activeOptions={{ exact: true }}
          >
            Books
          </Link>
          <Link
            to="/episodes"
            className="nav-link"
            activeProps={{ className: "nav-link is-active" }}
          >
            Episodes
          </Link>
          {/* Graph route hidden until production-ready
          <Link to="/graph" className="nav-link" activeProps={{ className: "nav-link is-active" }}>
            Graph
          </Link>
          */}
          <Link to="/chat" className="nav-link" activeProps={{ className: "nav-link is-active" }}>
            Chat
          </Link>
        </div>

        <div className="nav-tools">
          <HeaderAccount />
          <ThemeToggle />
        </div>
      </nav>
    </header>
  );
}
